<template>
  <div
    class="chart-summary-box"
    :class="isShowInfoAble ? 'cursor-pointer' : ''"
    :style="{ color: color }"
    @dblclick="isShowInfoAble ? $emit('on-click-data-info') : ''"
  >
    <div class="content">
      <div v-if="propsNumberIsString" style="font-size: max(1.25rem)">
        {{ propsNumberIsString }}
      </div>
      <div v-else style="font-size: max(2.5rem)">
        {{ cubicBezierNumber.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}
      </div>
      <div class="subtitle">
        {{ subtitle }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, Ref } from 'vue';
import { TransitionPresets, useTransition } from '@vueuse/core';

interface Props {
  number: number | string;
  subtitle: string;
  color: string;
  fontSize?: string;
  isShowInfoAble?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  number: 0,
  subtitle: '',
  color: 'black',
  isShowInfoAble: false,
});

defineEmits(['on-click-data-info']);

const duration = 3000;

const baseNumber: Ref<number> = ref(0);
const propsNumberIsString: Ref<string> = ref('');

const cubicBezierNumber = useTransition(baseNumber, {
  duration,
  transition: TransitionPresets.easeInOutCubic,
});

onMounted(() => {
  if (typeof props.number == 'string') {
    propsNumberIsString.value = props.number;
  } else if (typeof props.number == 'number') {
    baseNumber.value = props.number;
  }
});
</script>

<style lang="scss">
.chart-summary-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: inherit;

  .content {
    text-align: center;
    line-height: 1.2;

    .title {
      font-size: 3rem;
    }

    .subtitle {
      font-size: 1rem;
    }
  }
}
</style>
